<template>
  <div class="modal-root">
    <slot />

    <div v-for="modal in queue" :key="modal.id">
      <component :is="modal.component" v-bind="getProps(modal)" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { TAnyModal } from '@manager/modules/modals/composables/use-modals';
import { useModalQueue } from '@manager/modules/modals/composables/use-modals';

const { queue } = useModalQueue();

function getProps(modalInstance: TAnyModal) {
  return {
    ...(modalInstance.props || {}),
    resolve: modalInstance.resolve,
  };
}
</script>
